import { Col, Input, Row } from 'reactstrap';

interface DirectReport {
  id: string;
  firstName: string;
  lastName: string;
  status: string;
}

interface DirectReportsReassignmentProps {
  employeeFirstName: string;
  directReports: DirectReport[];
  supervisors: any[];
  value: string;
  onChange: (supervisorId: string) => void;
}

const DirectReportsReassignment = ({
  employeeFirstName,
  directReports,
  supervisors,
  value,
  onChange,
}: DirectReportsReassignmentProps) => {
  if (!directReports.length) return null;

  return (
    <>
      <hr />

      <h5 className="mt-4">DIRECT REPORTS</h5>
      <p className="text-muted">
        {employeeFirstName} currently supervises {directReports.length} employee(s). Choose who will supervise them once
        this request is submitted.
      </p>

      <Row className="d-flex align-items-start mt-4">
        <Col lg="4">
          <label className="form-control-label">New supervisor *</label>
          <p className="text-muted small">Applies to everyone listed on the right.</p>
        </Col>
        <Col lg="8">
          <Input type="select" value={value} onChange={(e) => onChange(e.target.value)} required>
            <option value="">Select a supervisor</option>
            {supervisors.map((supervisor: any) => {
              const supervisorName = `${supervisor.firstName || ''} ${supervisor.lastName || ''}`.trim();
              const displayName = supervisor?.roles?.includes('admin')
                ? `${supervisorName} - Admin`
                : `${supervisorName} - ${supervisor?.group?.name || ''}`;
              return (
                <option key={supervisor.userId} value={supervisor.userId}>
                  {displayName}
                </option>
              );
            })}
          </Input>
          <ul className="mt-3 mb-0 pl-3">
            {directReports.map((report) => (
              <li key={report.id}>
                {`${report.firstName} ${report.lastName}`.trim()}{' '}
                <span className="text-muted small">({report.status})</span>
              </li>
            ))}
          </ul>
        </Col>
      </Row>
    </>
  );
};

export default DirectReportsReassignment;
